module.exports = __webpack_public_path__ + "img/imagemissing1.4df0898a.jpg";